import React from "react";
import MuiList from "@mui/material/List";
import { Typography } from "@mui/material";

const List = (props) => {
  const { ...rest } = props;

  return (
    <MuiList
      {...rest}
      sx={{ bgcolor: "background.paper", width: "100%", ...props.sx }}
      subheader={
        props.subheader ? (
          <Typography variant="body1">{props.subheader}</Typography>
        ) : (
          <li />
        )
      }
    >
      {props.children}
    </MuiList>
  );
};

export default List;
